import { Component, Input, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../shared/modal/modal.component';
import { ExpenseCheckClaim } from '../../../core/models/expense-check.model';
import { AuthService } from "../../../core/services/auth.service";
import { Lightbox } from "ngx-lightbox";
import { StringHelper } from "../../../core/helpers/string-helper";
import { ModalSize } from "../../../shared/modal/modal-size.enum";

@Component({
  selector: 'app-check-expense-claim-list-modal',
  templateUrl: './check-expense-claim-list.component.html',
  styleUrls: ['./check-expense-claim-list.component.scss']
})

export class CheckExpenseClaimListModalComponent {
  @ViewChild('modal') modal: ModalComponent;
  @Input('claims') claims: ExpenseCheckClaim[];

  stringHelper = StringHelper;
  protected readonly ModalSize = ModalSize;

  constructor(public authService: AuthService, private lightbox: Lightbox) { }

  get modalLabel(): string {
    const count = this.claims?.length ?? 0;
    return `${count} Expense${count === 1 ? '' : 's'} found for this visit`;
  }

  show(): void {
    this.modal.show();
  }

  onClose(): void {
    this.modal.hide();
  }

  getBadgeLabel(expenseState: string) {
    switch (expenseState) {
      case 'AutomatedPaymentApproved':
        return 'Automated Payment Approved';
      case 'Processing':
        return 'Payment Processing';
      case 'AutomatedPaymentFailed':
        return 'Automated Payment Failed';
      default:
        return expenseState;
    }
  }

  public uploadIsPdf(uploadUrl: string) {
    let parts = uploadUrl.toLowerCase().split('?');
    return parts[0].endsWith('.pdf');
  }

  viewReceipt(imageUrl: string) {
    const album: { src: string, caption: string, thumb: string, downloadUrl: string }[] = [];
    album.push({ src: imageUrl, caption: '', thumb: imageUrl, downloadUrl: '' });

    this.lightbox.open(album, 0);
  }

}
